import { SUPER_ADMIN_ONLY } from "@excel-center/shared";
import { lazy } from "react";
import type { RouteObject } from "react-router";
import { ProtectedRoute } from "@/src/auth/components/protected-route";
import { SCHOOLS_ROUTES } from "@/src/schools/constants/schools-routes.constants";

const SchoolsListPage = lazy(() => import("@/src/schools/pages/schools-list.page"));

export const schoolsAuthedRoutes: RouteObject[] = [
	{
		path: SCHOOLS_ROUTES.schools,
		element: (
			<ProtectedRoute requiredRole={[...SUPER_ADMIN_ONLY]}>
				<SchoolsListPage />
			</ProtectedRoute>
		),
	},
];
